import { createContext, useState } from "react";

export const StatusContext = createContext();

export default function StatusProvider({ children }) {

    const [status, setStatus] = useState([]);
    const [statusNames, setStatusNames] = useState([]);

    return (
        <StatusContext.Provider
            value={{
                status,
                statusNames,
                setStatus,
                setStatusNames
            }}>
            {children}
        </StatusContext.Provider>
    )
}